/**
 * This is the master list of all actions that can be performed in the player
 */

export const DESTROY = '@@DESTROY';
export const INIT = '@@INIT';

export const PLAYER_EVENT_CAN_PLAY_THROUGH = 'PLAYER_EVENT_CAN_PLAY_THROUGH';
export const PLAYER_EVENT_DURATION_CHANGE = 'PLAYER_EVENT_DURATION_CHANGE';
export const PLAYER_EVENT_ENDED = 'PLAYER_EVENT_ENDED';
export const PLAYER_EVENT_ERROR = 'PLAYER_EVENT_ERROR';
export const PLAYER_EVENT_FULLSCREEN_CHANGE = 'PLAYER_EVENT_FULLSCREEN_CHANGE';
export const PLAYER_EVENT_LOADED_DATA = 'PLAYER_EVENT_LOADED_DATA';
export const PLAYER_EVENT_PAUSE = 'PLAYER_EVENT_PAUSE';
export const PLAYER_EVENT_PLAY = 'PLAYER_EVENT_PLAY';
export const PLAYER_EVENT_PLAYING = 'PLAYER_EVENT_PLAYING';
export const PLAYER_EVENT_READY = 'PLAYER_EVENT_READY';
export const PLAYER_EVENT_TIME_UPDATE = 'PLAYER_EVENT_TIME_UPDATE';
export const PLAYER_EVENT_VOLUME_CHANGE = 'PLAYER_EVENT_VOLUME_CHANGE';
export const PLAYER_EVENT_WAITING = 'PLAYER_EVENT_WAITING';

export const HLS_EVENT_MEDIA_ATTACHED = 'HLS_EVENT_MEDIA_ATTACHED';
export const HLS_EVENT_LEVEL_LOADED = 'HLS_EVENT_LEVEL_LOADED';
export const HLS_EVENT_MANIFEST_PARSED = 'HLS_EVENT_MANIFEST_PARSED';
export const HLS_EVENT_LOAD_ERROR = 'HLS_EVENT_LOAD_ERROR';
export const HLS_FRAG_CHANGED = 'HLS_FRAG_CHANGED';

export const FETCH_VIDEO_SOURCE_ERROR = 'FETCH_VIDEO_SOURCE_ERROR';

export const RECEIVE_VIDEO_SOURCE = 'RECEIVE_VIDEO_SOURCE';
export const RECEIVE_MEDIA_SOURCE = 'RECEIVE_MEDIA_SOURCE';
export const RECEIVE_CDN_TOKEN_SOURCE = 'RECEIVE_CDN_TOKEN_SOURCE';
export const RECEIVE_ACCESS_TOKEN = 'RECEIVE_ACCESS_TOKEN';
export const RECEIVE_VIDEO_PLAYER_DATA = 'RECEIVE_VIDEO_PLAYER_DATA';
export const RECEIVE_AUDITUDE_URL = 'RECEIVE_AUDITUDE_URL';
export const RECEIVE_AUDITUDE_TRACKING_DATA = 'RECEIVE_AUDITUDE_TRACKING_DATA';
export const RECONNECT_STREAM = 'RECONNECT_STREAM';

export const SET_CURRENT_TIME_STATE = 'SET_CURRENT_TIME_STATE';
export const SET_DURATION_STATE = 'SET_DURATION_STATE';
export const SET_ERROR_STATE = 'SET_ERROR_STATE';
export const SET_FIRST_TIME_STATE = 'SET_FIRST_TIME_STATE';
export const SET_LIVE_STATE = 'SET_LIVE_STATE';
export const SET_MUTE_STATE = 'SET_MUTE_STATE';
export const SET_PAUSE_STATE = 'SET_PAUSE_STATE';
export const SET_PLAYING_STATE = 'SET_PLAYING_STATE';
export const SET_STARTED_STATE = 'SET_STARTED_STATE';
export const SET_VIDEO_ID = 'SET_VIDEO_ID';
export const START_CONTENT = 'START_CONTENT';
export const SET_VOLUME_STATE = 'SET_VOLUME_STATE';
export const SET_VOLUME_DRAG_STATE = 'SET_VOLUME_DRAG_STATE';
export const SET_WAITING_STATE = 'SET_WAITING_STATE';
export const SET_AD_PLAYING_STATE = 'SET_AD_PLAYING_STATE';
export const SET_AD_SLOTS = 'SET_AD_SLOTS';
export const SET_ADS_RETURN_MIDROLL_TIME_STATE = 'SET_ADS_RETURN_MIDROLL_TIME_STATE';
export const SET_QUERY_PARAM_TIMECODE_SEEKED_STATE = 'SET_QUERY_PARAM_TIMECODE_SEEKED_STATE';
export const SET_VIDEO_PROGRESS_STATE = 'SET_VIDEO_PROGRESS_STATE';
export const SET_PLAYBACK_URL = 'SET_PLAYBACK_URL';
export const SET_TRACKING_URL = 'SET_TRACKING_URL';
export const SET_PROGRAM_DATETIME = 'SET_PROGRAM_DATETIME';
export const SET_CURRENT_AD = 'SET_CURRENT_AD';
export const SET_CURRENT_AD_POD = 'SET_CURRENT_AD_POD';
export const SET_CURRENT_AD_END_TIME = 'SET_CURRENT_AD_END_TIME';
export const SET_AD_TIME_REMAINING = 'SET_AD_TIME_REMAINING';
export const SET_CURRENT_AD_TIME_REMAINING = 'SET_CURRENT_AD_TIME_REMAINING';
export const SET_AD_END_TIME = 'SET_AD_END_TIME';
export const SET_AD_CLICK_HANDLER = 'SET_AD_CLICK_HANDLER';
export const CLEAR_CURRENT_AD = 'CLEAR_CURRENT_AD';
export const CLEAR_CURRENT_AD_POD = 'CLEAR_CURRENT_AD_POD';
export const SET_STREAM_BLOCKED = 'SET_STREAM_BLOCKED';
export const RETRY_PLAIN_STREAM = 'RETRY_PLAIN_STREAM';

export const TRACK_USER_INTERACTION = 'TRACK_USER_INTERACTION';
export const TRACK_VIDEO_BUFFERING = 'TRACK_VIDEO_BUFFERING';
export const TRACK_VIDEO_COMPLETE = 'TRACK_VIDEO_COMPLETE';
export const TRACK_VIDEO_START = 'TRACK_VIDEO_START';
export const TRACK_VIDEO_PAUSE = 'TRACK_VIDEO_PAUSE';
export const TRACK_VIDEO_PROGRESS = 'TRACK_VIDEO_PROGRESS';
export const TRACK_VIDEO_FIFTY = 'TRACK_VIDEO_FIFTY';
export const TRACK_PREROLL = 'TRACK_PREROLL';
export const TRACK_MIDROLL_START = 'TRACK_MIDROLL_START';
export const TRACK_MIDROLL_END = 'TRACK_MIDROLL_END';
export const TRACK_POSTROLL_START = 'TRACK_POSTROLL_START';
export const TRACK_POSTROLL_END = 'TRACK_POSTROLL_END';

export const ADS_EVENT_REQUEST_COMPLETE = 'ADS_EVENT_REQUEST_COMPLETE';
export const ADS_EVENT_SLOT_STARTED = 'ADS_EVENT_SLOT_STARTED';
export const ADS_EVENT_SLOT_ENDED = 'ADS_EVENT_SLOT_ENDED';
export const ADS_EVENT_IMPRESSION_STARTED = 'ADS_EVENT_IMPRESSION_STARTED';
export const ADS_EVENT_IMPRESSION_ENDED = 'ADS_EVENT_IMPRESSION_ENDED';
export const ADS_EVENT_ERROR = 'ADS_EVENT_ERROR';
export const ADS_REQUEST_FAILED = 'ADS_REQUEST_FAILED';
export const ADS_EVENT_CLICK = 'ADS_EVENT_CLICK';
export const ADS_START_PREROLL = 'ADS_START_PREROLL';
export const ADS_PREROLL_END = 'ADS_PREROLL_END';
export const ADS_MIDROLL_END = 'ADS_MIDROLL_END';
export const ADS_POSTROLL_END = 'ADS_POSTROLL_END';
export const ENABLE_ADS = 'ENABLE_ADS';
export const DISABLE_ADS = 'DISABLE_ADS';

export const ON_DOCUMENT_MOUSE_MOVE = 'ON_DOCUMENT_MOUSE_MOVE';
export const ON_DOCUMENT_MOUSE_UP = 'ON_DOCUMENT_MOUSE_UP';
export const ON_SHARE_CONTROL_CLICK = 'ON_SHARE_CONTROL_CLICK';
export const ON_SHARE_CONTROL_CLOSE = 'ON_SHARE_CONTROL_CLOSE';
export const ON_SHARE_SOCIAL = 'ON_SHARE_SOCIAL';
export const ON_COPY_CLICK = 'ON_COPY_CLICK';
export const ON_TIMECODE_SELECTION_CHANGE = 'ON_TIMECODE_SELECTION_CHANGE';
export const ON_TIMECODE_INPUT_CHANGE = 'ON_TIMECODE_INPUT_CHANGE';
export const ON_VOLUME_CONTROL_MOUSE_OUT = 'ON_VOLUME_CONTROL_MOUSE_OUT';
export const ON_VOLUME_CONTROL_MOUSE_OVER = 'ON_VOLUME_CONTROL_MOUSE_OVER';
export const ON_VOLUME_SLIDER_MOUSE_DOWN = 'ON_VOLUME_SLIDER_MOUSE_DOWN';
export const UPDATE_VOLUME_FROM_DRAG = 'UPDATE_VOLUME_FROM_DRAG';

export const ENABLE_THEATER_MODE = 'ENABLE_THEATER_MODE';
export const TOGGLE_THEATER_MODE = 'TOGGLE_THEATER_MODE';



// WEBPACK FOOTER //
// ./src/actions/ActionTypes.js